module.exports = __webpack_public_path__ + "static/media/Detail_Icon_02.bb5fb543.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_02.png
// module id = 1573
// module chunks = 0